<body>
  <app-nav-menu></app-nav-menu>
  <div style="padding: 15px">
    <router-outlet></router-outlet>
  </div>
</body>
